// src/components/Footer.jsx
import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 1rem 2rem;
  text-align: center;
  background-color: ${({ theme }) => theme.footerBackground};
  color: ${({ theme }) => theme.footerText};
`;

const Footer = () => {
  return (
    <FooterContainer>
      © {new Date().getFullYear()} BG Remover. All rights reserved, Generated by Zaid Ashraf
    </FooterContainer>
  );
};

export default Footer;
